import React from "react";
import styles from "../../assets/styles/Modal.module.css";

export default function Modal({ open, onClose, title, children, canClose = true }) {
   if (!open) return null;
   return (
      <div className={styles.backdrop} onClick={canClose ? onClose : undefined}>
         <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div className={styles.header}>
               <h4>{title}</h4>
               {canClose && (
                  <button className={styles.close} onClick={onClose} aria-label="Закрыть">×</button>
               )}
            </div>
            <div className={styles.body}>{children}</div>
         </div>
      </div>
   );
}

